import { Flex } from '@mantine/core';
import { TransactionAddButton } from './TransactionAddButton';
import { TransactionCoinCard } from './TransactionCoinCard';
export const TransactionCoins: React.FC = () => {
  return <Flex mt={20} gap={{
    base: 10,
    sm: 20
  }} wrap={{
    base: 'wrap',
    sm: 'nowrap'
  }}>
      <Flex wrap="nowrap" w={{
      base: '100%',
      sm: 'auto'
    }} gap={{
      base: 10,
      sm: 20
    }}>
        <TransactionCoinCard unit="usdt" coin={200} money={201.44} />
        <TransactionCoinCard unit="btc" coin={0.0212} money={1229.33} />
      </Flex>
      <TransactionAddButton />
    </Flex>;
};